/**
 * Desenvolvimento Site Institucional — escopo fechado (projeto).
 * Valor base: R$ 10.000.
 */

export const SITE_INSTITUCIONAL_NAME = 'Desenvolvimento Site Institucional'
export const SITE_INSTITUCIONAL_BASE_VALUE = 10000
export const SITE_INSTITUCIONAL_HOURLY_RATE = 180
export const SITE_INSTITUCIONAL_TOTAL_HOURS =
  Math.round((SITE_INSTITUCIONAL_BASE_VALUE / SITE_INSTITUCIONAL_HOURLY_RATE) * 100) / 100

export const SITE_INSTITUCIONAL_CATEGORIES = {
  paginaInicial: 'Arquitetura: Página Inicial',
  produtos: 'Arquitetura: Produtos',
  contato: 'Arquitetura: Contato',
  sobre: 'Arquitetura: Sobre Nós',
  paginaProduto: 'Arquitetura: Página de Produto',
  materiaisCliente: 'Itens a ser fornecidos pelo Cliente',
  funcionalidades: 'Funcionalidades Inclusas',
} as const

/**
 * Grade 2 colunas (PPT legado): esquerda = home/produtos/contato/materiais; direita = sobre/PDP/funcionalidades.
 * Y espaçado para ~35 itens com fonte compacta (7–8pt).
 */
export const SITE_INSTITUCIONAL_CATEGORY_COORDS = {
  [SITE_INSTITUCIONAL_CATEGORIES.paginaInicial]: { x: 38, y: 9 },
  [SITE_INSTITUCIONAL_CATEGORIES.produtos]: { x: 38, y: 30 },
  [SITE_INSTITUCIONAL_CATEGORIES.contato]: { x: 38, y: 42 },
  [SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente]: { x: 38, y: 56.4 },
  [SITE_INSTITUCIONAL_CATEGORIES.sobre]: { x: 68, y: 9 },
  [SITE_INSTITUCIONAL_CATEGORIES.paginaProduto]: { x: 68, y: 26 },
  [SITE_INSTITUCIONAL_CATEGORIES.funcionalidades]: { x: 68, y: 52 },
} as const

export const SITE_INSTITUCIONAL_PROPOSAL_LAYOUT = {
  leftBlockWidth: 35,
  titleY: 7.1,
  projectTypeY: 16.4,
  descriptionY: 27.3,
  bonusY: 48,
  priceY: 82.8,
  paymentY: 90,
  loyaltyY: 74.8,
  planTitleY: 2.7,
  serviceBlockX: 38,
  serviceBlockGap: 68,
  serviceBlockStartY: 10,
  categoryCoords: { ...SITE_INSTITUCIONAL_CATEGORY_COORDS },
} as const

export const siteInstitucionalDeliverables = [
  {
    name: 'Banner principal institucional',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 3,
  },
  {
    name: 'Apresentação da empresa',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 2.5,
  },
  {
    name: 'Categorias / áreas de atuação',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 2.5,
  },
  {
    name: 'Listagem de produtos',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 3,
  },
  {
    name: 'Newsletter',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Rodapé com navegação e contato',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaInicial,
    quantity: '1',
    hours: 2.5,
  },
  {
    name: 'Grid de produtos (até 12 produtos)',
    category: SITE_INSTITUCIONAL_CATEGORIES.produtos,
    quantity: '1',
    hours: 4,
  },
  {
    name: 'Card com imagem, nome e link',
    category: SITE_INSTITUCIONAL_CATEGORIES.produtos,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Formulário de contato funcionando',
    category: SITE_INSTITUCIONAL_CATEGORIES.contato,
    quantity: '1',
    hours: 3,
  },
  {
    name: 'Telefones, e-mail e WhatsApp',
    category: SITE_INSTITUCIONAL_CATEGORIES.contato,
    quantity: '1',
    hours: 1.5,
  },
  {
    name: 'Mapa de localização',
    category: SITE_INSTITUCIONAL_CATEGORIES.contato,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'História da empresa',
    category: SITE_INSTITUCIONAL_CATEGORIES.sobre,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Missão, visão e valores',
    category: SITE_INSTITUCIONAL_CATEGORIES.sobre,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Diferenciais',
    category: SITE_INSTITUCIONAL_CATEGORIES.sobre,
    quantity: '1',
    hours: 1.5,
  },
  {
    name: 'Fotos institucionais (Opcional)',
    category: SITE_INSTITUCIONAL_CATEGORIES.sobre,
    quantity: 'Opcional',
    hours: 1,
  },
  {
    name: 'Imagem principal do produto',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Galeria adicional (Opcional)',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: 'Opcional',
    hours: 1,
  },
  {
    name: 'Descrição completa',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: '1',
    hours: 2.5,
  },
  {
    name: 'Aplicações e benefícios',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Especificações técnicas',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Botão de solicitação de orçamento',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: '1',
    hours: 1,
  },
  {
    name: 'Ficha técnica (PDF) (se disponível)',
    category: SITE_INSTITUCIONAL_CATEGORIES.paginaProduto,
    quantity: 'Opcional',
    hours: 1,
  },
  {
    name: 'Logo em alta resolução',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Paleta de cores (se houver)',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Textos institucionais',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Fotos dos produtos e imagens',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Informações completas dos produtos (descrição, aplicações, especificações, benefícios)',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Ficha técnica (PDF) (Opcional)',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Opcional',
    hours: 0,
  },
  {
    name: 'Dados de contato (WhatsApp, telefones, endereço, e-mail)',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Cliente',
    hours: 0,
  },
  {
    name: 'Fotos institucionais (Opcional)',
    category: SITE_INSTITUCIONAL_CATEGORIES.materiaisCliente,
    quantity: 'Opcional',
    hours: 0,
  },
  {
    name: 'Site 100% responsivo (mobile/desktop)',
    category: SITE_INSTITUCIONAL_CATEGORIES.funcionalidades,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Otimização de performance',
    category: SITE_INSTITUCIONAL_CATEGORIES.funcionalidades,
    quantity: '1',
    hours: 1.5,
  },
  {
    name: 'SEO técnico preparado',
    category: SITE_INSTITUCIONAL_CATEGORIES.funcionalidades,
    quantity: '1',
    hours: 2,
  },
  {
    name: 'Integração com Google Analytics',
    category: SITE_INSTITUCIONAL_CATEGORIES.funcionalidades,
    quantity: '1',
    hours: 1,
  },
  {
    name: 'Formulários com envio por e-mail',
    category: SITE_INSTITUCIONAL_CATEGORIES.funcionalidades,
    quantity: '1',
    hours: 1.5,
  },
] as const

function buildServicesFromDeliverables(
  deliverables: ReadonlyArray<{
    name: string
    category: string
    quantity: string
    hours?: number
  }>,
) {
  const byCategory = new Map<
    string,
    Array<{ name: string; isIncluded: boolean; quantity: string; hours: number }>
  >()
  for (const d of deliverables) {
    const list = byCategory.get(d.category) ?? []
    list.push({
      name: d.name,
      isIncluded: true,
      quantity: d.quantity,
      hours: Number(d.hours ?? 0),
    })
    byCategory.set(d.category, list)
  }
  return Array.from(byCategory.entries()).map(([category, services]) => ({ category, services }))
}

export function buildSiteInstitucionalConfig() {
  const deliverables = siteInstitucionalDeliverables.map((d) => ({
    ...d,
    hours: Number(d.hours ?? 0),
  }))
  const targetHours =
    Math.round((SITE_INSTITUCIONAL_BASE_VALUE / SITE_INSTITUCIONAL_HOURLY_RATE) * 100) / 100
  let devHours = Math.round(
    deliverables.filter((d) => d.hours > 0).reduce((acc, d) => acc + d.hours, 0) * 100,
  ) / 100
  const hoursGap = Math.round((targetHours - devHours) * 100) / 100
  if (hoursGap !== 0) {
    const anchor = [...deliverables].reverse().find((d) => d.hours > 0)
    if (anchor) anchor.hours = Math.round((anchor.hours + hoursGap) * 100) / 100
    devHours = targetHours
  }

  return {
    projectType: 'Projeto Fechado',
    showBonus: true,
    bonus: 'SEO técnico + performance + Analytics',
    duration: 1,
    hourlyRate: SITE_INSTITUCIONAL_HOURLY_RATE,
    totalHours: devHours,
    suggestedValue: SITE_INSTITUCIONAL_BASE_VALUE,
    pricing: {
      entry: SITE_INSTITUCIONAL_BASE_VALUE,
      total: SITE_INSTITUCIONAL_BASE_VALUE,
      installments: 1,
      installmentValue: SITE_INSTITUCIONAL_BASE_VALUE,
      recorrente: false,
      duracao: 1,
    },
    services: buildServicesFromDeliverables(deliverables),
    deliverables,
    proposalLayout: { ...SITE_INSTITUCIONAL_PROPOSAL_LAYOUT },
  }
}

export const siteInstitucionalPlanSeed = {
  name: SITE_INSTITUCIONAL_NAME,
  description:
    'Site institucional completo: home, produtos (até 12), contato, sobre, página de produto, checklist de materiais do cliente e funcionalidades (responsivo, performance, SEO, Analytics, formulários).',
  baseValue: SITE_INSTITUCIONAL_BASE_VALUE,
  category: 'Desenvolvimento',
  type: 'DEMANDAS_ESPECIFICAS' as const,
  isActive: true,
  config: buildSiteInstitucionalConfig(),
}
